<template>
  <div class="contact-card mb-3">
    <view-contact-modal :contact="contact"></view-contact-modal>
    <edit-contact-modal @contact-updated="handleContactUpdated" :contact="contact"></edit-contact-modal>
    <div class="d-flex align-items-center inner">
      <div class="flex-grow-1">
        <a href="#" @click="openViewContactModal"><b v-b-tooltip.hover :title="contactTooltip" class="contact-name">{{ contact.first_name }}
          {{ contact.last_name }}</b></a>
      </div>
      <div class="flex-shrink-1">
        <b-dropdown variant="white" right toggle-class="text-muted pt-0 pr-0 mt-2">
          <template v-slot:button-content>
            <i class="mdi mdi-dots-horizontal font-size-18"></i>
          </template>
          <b-dropdown-item @click="edit">Edit</b-dropdown-item>
          <b-dropdown-item @click="requestRemoveContact" v-if="!isPrimaryContact" variant="danger">Remove
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div class="inner inner-bottom">
      <div class="mb-1" v-if="contact.email">
        {{ contact.email }}
      </div>
      <div v-if="contact.email">
        {{ contact.phone_number }}
      </div>
      <div v-if="contact.notes" class="mt-2">
       {{ contact.notes }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters, mapActions} from "vuex";
import EditContactModal from "./Contact/EditContactModal";
import ViewContactModal from "./Contact/ViewContactModal";

export default {
  name: "Contact",
  components: {ViewContactModal, EditContactModal},
  props: ['contact'],

  methods: {
    ...mapActions('ticketViewer', {
      reloadTicket: 'reloadTicket'
    }),

    openViewContactModal() {
      this.$bvModal.show('view-contact-' + this.contact.id + '-modal');
    },

    edit() {
      this.$bvModal.show('edit-contact-' + this.contact.id + '-modal');
    },

    requestRemoveContact() {
      let vm = this;
      swal({
        title: "Are you sure you want to remove this contact?",
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: "Delete"
        },
        dangerMode: true,
      }).then((shouldRemove) => {
        if (shouldRemove) {
          vm.removeContact();
        }
      });
    },

    removeContact() {
      let vm = this;
      vm.isSaving = true;
      axios.delete(API_BASE + '/tickets/' + this.ticket.id + '/contacts/' + vm.contact.id).then(r => {
        vm.isSaving = false;
        vm.reloadTicket();
        this.$notify.success({
          title: 'Success!',
          message: 'Contact removed successfully'
        });
      }).catch(e => {
        vm.isSaving = false;
        vm.notifyErrors(e);
      });
    },

    handleContactUpdated() {
      this.reloadTicket();
    }
  },

  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    }),

    isPrimaryContact() {
      return this.contact.id === this.ticket.primary_contact_id;
    },

    contactTooltip() {
      if (this.isPrimaryContact) {
        return "Primary contact"
      } else {
        return "Secondary contact"
      }
    }
  }
}
</script>

<style scoped lang="scss">
.contact-card {
  background: #fff;
  border-radius: 5px;

  .contact-name {
    font-weight: 600;
    color: #2c5cc5;
  }

  .inner {
    padding-left: 15px;
    padding-right: 15px;
  }

  .inner-bottom {
    padding-top: 0;
    padding-bottom: 12px !important;
    font-size: 12px;
  }
}
</style>
